import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import BASE_URL from '../../config';

const initialState = {
  contributors: [],
  totalPages: 1,
  totalCount: 0,
  currentPage: 1,
  status: 'idle',
  error: null,
};

export const fetchTopContributors = createAsyncThunk(
  'topContributors/fetchTopContributors',
  async ({ page = 1, pageSize = 10 }, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams({
        page,
        page_size: pageSize,
      });

      const response = await fetch(`${BASE_URL}/users/v1/ranked/?${queryParams.toString()}`, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        return rejectWithValue(errorDetails);
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const topContributorsSlice = createSlice({
  name: 'topContributors',
  initialState,
  reducers: {
    resetContributors: (state) => {
      state.contributors = [];
      state.status = 'idle';
      state.totalPages = 1;
      state.totalCount = 0;
      state.currentPage = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTopContributors.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchTopContributors.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.contributors = action.payload.data || [];
        state.totalPages = action.payload.total_page || 1;
        state.totalCount = action.payload.total_items || 0;
        state.currentPage = action.payload.current_page || 1;
      })
      .addCase(fetchTopContributors.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export const { resetContributors } = topContributorsSlice.actions;
export default topContributorsSlice.reducer;
